export default [
  {
    path: '/users',
    name: 'users',
    component: () => import('@/views/index.vue'),
    meta: {
      title: 'Ползователи',
    },
    children: [
      {
        path: '',
        name: 'users-list',
        component: () => import('@/views/users/users.vue'),
        meta: {},
      },
      {
        path: 'add',
        name: 'users-add',
        component: () => import('@/views/users/add.vue'),
        meta: {
          title: 'Добавить',
        },
      },
      {
        path: ':id(\\d+)/edit',
        name: 'users-edit',
        props: true,
        component: () => import('@/views/users/edit.vue'),
        meta: {
          title: 'Изменить',
        },
      },
    ],
  },
]
